// extracted by mini-css-extract-plugin
export default {"doneContainer":"AllDone_doneContainer__E-Dk-","buttonWidth":"AllDone_buttonWidth__HVKlO"};